import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { usePrefersReducedMotion } from "./reducedMotion";

const HOLD_MS = 2400;
const FADE_MS = 400;

/**
 * Cycles through `words` in place with a fade; holds the first word under
 * reduced motion.
 *
 * The slot sizes itself to the current word, so put it at the END of the
 * sentence: nothing follows it, so nothing reflows when the word changes and
 * no width has to be reserved or animated.
 */
const CyclingWord = ({ words, className = "" }) => {
	const [idx, setIdx] = useState(0);
	const [visible, setVisible] = useState(true);
	const reduced = usePrefersReducedMotion();

	useEffect(() => {
		if (reduced || words.length < 2) return undefined;
		let swap;
		const id = setInterval(() => {
			setVisible(false);
			swap = setTimeout(() => {
				setIdx((i) => (i + 1) % words.length);
				setVisible(true);
			}, FADE_MS);
		}, HOLD_MS);
		return () => {
			clearInterval(id);
			clearTimeout(swap);
		};
	}, [words.length, reduced]);

	return (
		<span
			className={`inline-block align-baseline whitespace-nowrap ${className}`.trim()}
			style={{
				opacity: visible ? 1 : 0,
				transform: visible ? "translateY(0)" : "translateY(-0.15em)",
				transition: "opacity 0.4s ease, transform 0.4s ease",
			}}
		>
			{words[idx]}
		</span>
	);
};

CyclingWord.propTypes = {
	words: PropTypes.arrayOf(PropTypes.string).isRequired,
	className: PropTypes.string,
};

export default CyclingWord;
